import React from 'react';
import { DmsTab } from 'Components';
import { hashHistory } from 'react-router';
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Radio,
  Table,
  message,
  Cascader,
} from 'antd';
import {
  specDetail,
  specAdd,
  specUpdate,
  belongSpeclist,
  deleteSpecParam,
  belongSpecValuelist,
} from '../../service/productSpec';
import { categoryTree } from '../../service/category';
import { nameValidator } from '../../utils/regexp.js';
import {
  unique,
  showSpin,
  hideSpin,
} from 'Utils';

const Option = Select.Option;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { TextArea } = Input;

class Productspecadd extends React.Component {
  constructor(props) {
    super(props);
    this.id = props.params.id === '0' ? 0 : props.params.id;
    this.state = {
      opts: ['新建规格'],
      detail: {},
      dataSource: [],
      belongSpecList: [],
      belongSpecValueList: [],
      tree: [],
    };
    this.onCellChange = this.onCellChange.bind(this);
    this.clearBelongParamId = this.clearBelongParamId.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.getCategory = this.getCategory.bind(this);
    this.getBelongSpeclist = this.getBelongSpeclist.bind(this);
    this.getDetail = this.getDetail.bind(this);
    this.checkSortOrder = this.checkSortOrder.bind(this);
  }

  componentDidMount() {
    this.getCategory().then(() => {
      if (this.id) {
        this.setState({
          opts: ['编辑规格'],
        });
        //根据传过来的index，获取特定的值，并赋值给detail
        this.getDetail();
      }
    });
  }

  //获取详情
  getDetail() {
    const { treeCache } = this.state;
    specDetail({ id: this.id }).then(result => {
      if (result.status) {
        let data = result.data;
        // categoryPath
        data.categoryPath = data.categoryPath ? data.categoryPath.replace(/\./g, ',') : '';
        data.categoryPathCode = data.categoryPathCode ? data.categoryPathCode.replace(/\./g, ',') : '';
        // categoryPathCode
        data = {
          ...data,
          categoryId: data.categoryId ? `${data.categoryId}` : undefined,
          categoryPath: (data.categoryPath || '').split(',').filter(x => !!x),
          categoryPathCode: (data.categoryPathCode || '').split(',').filter(x => !!x),
          belongSpecId: data.belongSpecId ? `${data.belongSpecId}` : undefined,
          removeFlag: data.removeFlag ? `${data.removeFlag}` : undefined,
          specValueList: (data.specValueList || []).map(x => ({
            ...x,
            key: `${Math.random()}`,
            belongParamId: !!x.belongParamId ? `${x.belongParamId}`.split(',') : undefined,
          })),
        };
        let tree = [];
        if(data.propertyCategoryCode === '本体') {
          tree = treeCache.filter(x => !/配件/.test(x.label))
        } else {
          tree = treeCache.filter(x => /配件/.test(x.label))
        }
        this.setState({
          tree,
          detail: data,
          dataSource: data.specValueList,
        }, () => {
          this.getBelongSpeclist({
            categoryId: data.categoryId,
            propertyCategoryCode: data.propertyCategoryCode,
          }).then(() => {
            !!data.belongSpecId && this.getBelongSpecValuelist(data.belongSpecId);
          });
        });
      } else {
        message.error(result.message);
      }
    });
  }

  //获取分类
  getCategory() {
    return new Promise((resolve, reject) => {
      categoryTree({ id: 1 }).then(result => {
        if (result.status) {
          const filterEmpty = (list) => list.map(x => {
            let key = x.code; // 实际使用的业务数据是 code；
            if (x.children && x.children.length) {
              return {
                ...x,
                key: key, // 使用实际业务数据重新给 key 赋值
                value: key, // 使用实际业务数据重新给 value 赋值
                isLeaf: false,
                children: filterEmpty(x.children),
              };
            }
            return {
              ...x,
              key: key,
              value: key,
              isLeaf: true,
              children: undefined,
            };
          });
          let list = filterEmpty(result.data || []);
          list = list.map(x => ({
            ...x,
            disabled: /配件/.test(x.label),
          }))
          this.setState({
            treeCache: filterEmpty(result.data || []),
            tree: list
          }, () => {
            resolve();
          });
        } else {
          resolve();
          message.error(result.message);
        }
      });
    })
  }

  // 检查产品分类、适用对象是否有值，并根据它们的值获取 从属规格 下拉框数据
  checkFirstCondition() {
    const { validateFields } = this.props.form;
    validateFields(['categoryPath', 'categoryId', 'propertyCategoryCode'], (err, values) => {
      if (!err) {
        if (values.categoryId) {
          this.getBelongSpeclist({
            categoryId: values.categoryId,
            propertyCategoryCode: values.propertyCategoryCode,
          })
        } else {
          this.setState({ belongSpecList: [] });
        }
      }
    });
  }

  getBelongSpeclist(params) {
    return new Promise((resolve, reject) => {
      belongSpeclist(params).then(res => {
        if (res.status) {
          let list = res.data.map(x => ({
            ...x,
            text: x.propertyName,
            value: `${x.id}`,
          }))
          if(this.id) { // 从属规格不能选自己
            list = list.filter(x => x.value !== this.id);
          }
          this.setState({
            belongSpecList: list,
          }, () => {
            resolve()
          });
        }
      });
    })
  }

  getBelongSpecValuelist(specId) {
    const { belongSpecList, dataSource } = this.state;
    const { validateFields, getFieldValue } = this.props.form;
    const oldSpecId = getFieldValue('belongSpecId');
    const selectSpec = belongSpecList.filter(x => x.value === specId)[0];
    if (oldSpecId !== specId) {
      this.setState({
        dataSource: dataSource.map(x => ({ ...x, belongParamId: undefined })),
      });
    }
    validateFields(['categoryPath', 'categoryId', 'propertyCategoryCode'], (err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        belongSpecValuelist({
          categoryId: values.categoryId,
          propertyCategoryCode: values.propertyCategoryCode,
          propertyNum: selectSpec.propertyNum,
        }).then(res => {
          if (res.status) {
            this.setState({
              belongSpecValueList: res.data.map(x => ({
                text: x.propertyDescName,
                value: `${x.id}`,
              })),
            });
          }
        });
      }
    });
  }

  onCellChange = (index, key, value) => {
    const { dataSource } = this.state;
    if(key === 'propertyDescName' && dataSource.some(x => x.propertyDescName === value)) {
      message.error('规格值不能重复')
    }
    this.setState({
      dataSource: dataSource.map((x, i) => {
        return {
          ...x,
          [key]: index === i ? value : x[key],
        };
      }),
    });
  };

  clearBelongParamId = () => {
    this.setState({
      dataSource: this.state.dataSource.map(x => ({
        ...x,
        belongParamId: undefined,
      })),
    });
  };

  onDelete = (key) => {
    const dataSource = [...this.state.dataSource];
    var delObj = dataSource.filter(item => item.key === key)[0] || {};
    var newDataSource = dataSource.filter(item => item.key !== key);
    if (delObj.id) {
      deleteSpecParam({ id: delObj.id }).then(res => {
        if (res.status) {
          this.setState({
            dataSource: newDataSource,
          });
        } else {
          message.error('删除规格值失败');
        }
      });
    } else {
      this.setState({
        dataSource: newDataSource,
      });
    }
  };

  handleAdd = () => {
    const { dataSource } = this.state;
    const newData = {
      key: `${Math.random()}`,
      propertyDescName: '',
      belongParamId: undefined,
      sortNum: '',
    };
    this.setState({
      dataSource: [...dataSource, newData],
    });
  };

  //取消按钮
  cancelHandle() {
    hashHistory.goBack();
  }

  //提交按钮
  submitHandle() {
    const { dataSource } = this.state;
    const { validateFields, getFieldsValue } = this.props.form;
    if (dataSource.some(x => !x.propertyDescName)) {
      message.error('请填写全部规格值');
      return;
    }
    let tmlList = unique(dataSource, 'propertyDescName');
    if(tmlList.length !== dataSource.length ) {
      message.error('规格值不能重复');
      return
    }
    validateFields((errors) => {//表单校验
      if (errors) {
        return;
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue(), //获取用户输入
      };
      data.categoryPath = data.categoryPath.join();
      data.specValueList = (dataSource || []).map(x => ({
        ...x,
        belongParamId: (x.belongParamId || []).join()
      }));

      showSpin();
      if (this.id) {
        data.id = this.state.detail.id;
        specUpdate(data).then(result => {
          hideSpin();
          if (result.status) {
            message.success(result.message);
            hashHistory.goBack();
          } else {
            message.error(result.message);
          }
        });
      } else {
        specAdd(data).then(result => {
          hideSpin();
          if (result.status) {
            message.success(result.message);
            hashHistory.goBack();
          } else {
            message.error(result.message);
          }
        });
      }
    });
  }

  //排序正则
  checkSortOrder(rule, value, callback) {
    const vaReg = /^\d{1,}$/;
    if (value) {
      if (!(vaReg.test(value))) {
        callback('排序只可输入整数');
      }
      callback();
    }
    callback();
  }

  CascaderFilter = (inputValue, path) => {
    return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
  };
  propertyCategoryCodeChangeHandle = (val) => {
    const { treeCache } = this.state;
    let tree = [];
    if(val === '附件') {
      tree = treeCache.filter(x => /配件/.test(x.label));
    } else {
      tree = treeCache.filter(x => !/配件/.test(x.label));
    }
    this.setState({
      tree,
    }, () => {
      this.props.form.setFields({
        belongSpecId: {
          value: undefined,
          errors: undefined,
        },
        categoryPath: {
          value: undefined,
          errors: undefined,
        },
        categoryId: {
          value: '',
          errors: undefined,
        },
      });
    });
  }
  render() {
    const { opts, detail, dataSource, belongSpecList, belongSpecValueList } = this.state;
    const { getFieldDecorator, setFields } = this.props.form;
    const tablevalue = {
      size: 'small',
      pagination: false,
      bordered: true,
      dataSource: dataSource,
      columns: [
        {
          title: '',
          dataIndex: 'key',
          render: (text, record, index) => index + 1,
        }, {
          title: '值',
          dataIndex: 'propertyDescName',
          width: '30%',
          render: (text, record, index) => (
            <Input
              key={record.key}
              value={text}
              onChange={(e) => this.onCellChange(index, 'propertyDescName', e.target.value)}
            />
          ),
        }, {
          title: '排序',
          dataIndex: 'sortNum',
          width: '30%',
          render: (text, record, index) => (
            <Input
              key={record.key}
              value={text}
              onChange={(e) => this.onCellChange(index, 'sortNum', e.target.value)}
            />
          ),
        }, {
          title: '从属规格值',
          dataIndex: 'belongParamId',
          width: '30%',
          render: (text, record, index) => (
            <Select
              key={record.key}
              value={text}
              mode="multiple"
              allowClear
              onChange={(val) => this.onCellChange(index, 'belongParamId', val)}>
              {
                belongSpecValueList.map(x => <Option key={x.value}>{x.text}</Option>)
              }
            </Select>),
        }, {
          title: '操作',
          dataIndex: 'operation',
          render: (text, record, index) => <a onClick={() => this.onDelete(record.key)}>删除</a>,
        },
      ],
    };
    return <div className='dms-body'>
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box" style={{ backgroundColor: '#fff' }}>
        <Form layout="horizontal">

          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="规格编码" hasFeedback>
                {getFieldDecorator('propertyNum', {
                  initialValue: detail.propertyNum || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入规格名称',
                    },
                    {
                      validator: nameValidator,
                    },
                  ],
                })(<Input placeholder="请输入规格名称" />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="规格名称" hasFeedback>
                {getFieldDecorator('propertyName', {
                  initialValue: detail.propertyName || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入规格名称',
                    },
                    {
                      validator: nameValidator,
                    },
                  ],
                })(<Input placeholder="请输入规格名称" />)}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div style={{ display: 'none' }}>
                <FormItem label="商品分类Id" hasFeedback>
                  {getFieldDecorator('categoryId', {
                    initialValue: detail.categoryId || '',
                    rules: [
                      {
                        required: true,
                        message: '请选择产品分类',
                      },
                    ],
                  })(<Input placeholder="请选择产品分类" />)}
                </FormItem>
              </div>
              <FormItem label="所属分类：" hasFeedback>
                {getFieldDecorator('categoryPath', {
                  initialValue: detail.categoryPathCode || undefined,
                  getValueFromEvent: (value, selectedOptions) => {
                    let lastOption = selectedOptions.pop();
                    setFields({
                      belongSpecId: {
                        value: undefined,
                        errors: undefined,
                      },
                      categoryId: {
                        value: lastOption ? lastOption.categoryId || '' : '',
                        errors: undefined,
                      },
                    });
                    this.clearBelongParamId();
                    return value;
                  },
                  rules: [
                    {
                      required: true,
                      message: '请选择所属分类',
                    },
                  ],
                })(
                  <Cascader
                    options={this.state.tree}
                    placeholder="请选择所属分类"
                    showSearch={{ filter: this.CascaderFilter }}
                  />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="适用对象">
                {getFieldDecorator('propertyCategoryCode', {
                  initialValue: detail.propertyCategoryCode || '本体',
                  getValueFromEvent: (e) => {
                    this.propertyCategoryCodeChangeHandle(e.target.value)
                    return e.target.value;
                  },
                  rules: [
                    {
                      required: true,
                      message: '请选择规格适用对象',
                    },
                  ],
                })(<RadioGroup>
                  <Radio value='本体'>本体</Radio>
                  <Radio value="附件">附件</Radio>
                </RadioGroup>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label={<span>从属规格：<span className="gray">不选则属于大类的公用规格</span></span>}>
                {getFieldDecorator('belongSpecId', {
                  initialValue: detail.belongSpecId,
                  rules: [
                    {
                      required: false,
                      message: '请选择从属规格',
                    },
                  ],
                  getValueFromEvent: (e) => {
                    this.getBelongSpecValuelist(e);
                    return e;
                  },
                })(<Select onFocus={() => this.checkFirstCondition()} placeholder="隶属某一个规格">
                  {belongSpecList.map(x => <Option key={x.value}>{x.text}</Option>)}
                </Select>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="有效性">
                {getFieldDecorator('activeFlag', {
                  initialValue: (detail !== null && detail.activeFlag === 0) ? '0' : '1',
                  rules: [
                    {
                      required: true,
                      message: '请选择是否有效',
                    },
                  ],
                })(<RadioGroup>
                  <Radio value='1'>有效</Radio>
                  <Radio value="0">无效</Radio>
                </RadioGroup>)}
              </FormItem>
            </Col>
          </Row>

          <FormItem label="描述">
            {getFieldDecorator('remark', {
              initialValue: detail.remark || undefined,
            })(<TextArea rows={4} />)}
          </FormItem>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="排序">
                {getFieldDecorator('sortNum', {
                  initialValue: detail.sortNum || undefined,
                  rules: [
                    {
                      validator: this.checkSortOrder,
                    },
                  ],
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>

          <Row>
            <FormItem label="规格值">
              <Button className="editable-add-btn" onClick={() => this.handleAdd()}>添加</Button>
              <Table {...tablevalue} />
            </FormItem>
          </Row>

        </Form>
      </div>
    </div>;
  }
}

export default Form.create()(Productspecadd);



// WEBPACK FOOTER //
// ./src/routes/productSpec/add.js